import React, { Component } from 'react';
import './styles.css';

class PopUpMailLayoutHeader extends Component {
	render() {
		return (
			<div className="pop-up-mail-layout-header">{this.props.children}</div>
		);
	}
}

export default PopUpMailLayoutHeader;
